import {
  detectPosition,
  type ElementLocationObsolete,
  type ElementPositionType,
  getElementLocationObsolete
} from "@common/lib/position";
import { Common } from "@common/types";
import { type ManualTooltipProps } from "./Manual/component";

export type PositionType = ElementPositionType;

export type TooltipLocation = ElementLocationObsolete;

export const getElementRect = (el: HTMLElement): Common.Rect => {
  return el.getBoundingClientRect();
};

export const isMouseOver = (el: HTMLElement) => {
  return el && el.matches(":hover");
};

export const getPointerLocation = (
  toggleRect: Common.Rect,
  tooltipRect: Common.Rect,
  preferredPosition?: PositionType
): Common.LeftTop => {
  const position = detectPosition(toggleRect, tooltipRect, preferredPosition);

  let left = 0;
  let top = 0;
  switch (position) {
    case "bottom":
    case "top": {
      left = toggleRect.left - tooltipRect.left + toggleRect.width / 2;
      break;
    }
    case "left":
    case "right": {
      top = toggleRect.top - tooltipRect.top + toggleRect.height / 2;
      break;
    }
    default:
      throw new Error(`Unexpected position ${position}`);
  }

  return {
    left,
    top
  };
};

export const getTooltipLocation = (
  toggleRect: Common.Rect,
  tooltipRect: Common.Rect,
  preferredPosition?: PositionType
): TooltipLocation => {
  return getElementLocationObsolete(toggleRect, tooltipRect, preferredPosition, MARGIN);
};

const MARGIN = 8;
export const calcPointerLocation = (
  toggleRef: HTMLElement,
  tooltipRef: HTMLElement,
  position?: PositionType
): Common.LeftTop => {
  const tooltipRect = getElementRect(tooltipRef);
  const toggleRect = getElementRect(toggleRef);

  return getPointerLocation(toggleRect, tooltipRect, position);
};
export const calcTooltipLocation = (
  toggleRef: HTMLElement,
  tooltipRef: HTMLElement,
  position?: PositionType
): TooltipLocation => {
  const tooltipRect = getElementRect(tooltipRef);
  const toggleRect = getElementRect(toggleRef);

  return getTooltipLocation(toggleRect, tooltipRect, position);
};

export const calcManualTooltipLocation = (tooltipRef: HTMLElement, props: ManualTooltipProps): TooltipLocation => {
  const tooltipRect = getElementRect(tooltipRef);
  const leftTop = props.leftTop!;
  return getTooltipLocation(
    { left: leftTop.left, bottom: leftTop.top, right: leftTop.left, top: leftTop.top, height: 0, width: 0 },
    tooltipRect,
    props.position
  );
};

export const MOUSE_OVER_CHECK_INTERVAL = 60;
